<template>
  <div
    @click="goDetail(courseInfo.id)"
    :class="{
      'h5-course-card': isH5,
      'course-card': !isH5,
      'small-card': type === 'small',
      'big-card': type === 'big',
      'hidden-ios': iosInReview && courseInfo.goods.price > 0,
    }"
  >
    <div class="cover-wrap">
      <div class="cover-cont">
        <!-- 免费课标识 -->
        <img
          v-if="courseInfo.goods.fee_type === 1"
          class="free-icon"
          src="../../../assets/images/free-icon.png"
          alt=""
        />
        <img
          class="cover"
          :src="courseInfo.cover_url + '?imageView2/0/w/480'"
          alt=""
        />
      </div>
      <!-- 课时信息 -->
      <div v-if="!isH5" class="data-STATS">
        <span class="lesson">{{ courseInfo.lesson_count }}课时</span>
        <span
          v-if="
            courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
          "
        >
          <span class="separate">|</span
          >{{ million(courseInfo.enrollment_count) }}人报名</span
        >
      </div>
    </div>
    <div class="info-wrap">
      <div class="info-top">
        <p class="title">
          {{ courseInfo.course_name }}
        </p>
        <p
          class="tag-wrap"
          v-if="courseInfo.goods && courseInfo.goods.goods_tag"
        >
          <el-tag
            v-for="(item, index) in courseInfo.goods.goods_tag.split(',')"
            :key="index"
            >{{ item }}</el-tag
          >
        </p>
      </div>

      <div class="lesson-info">
        <!-- 课时信息 -->
        <p class="data-STATS" v-if="isH5">
          <span class="lesson">{{ courseInfo.lesson_count }}课时</span>
          <span
            v-if="
              courseInfo.goods && courseInfo.goods.show_enrollment_count === 1
            "
            ><span class="separate">|</span
            >{{ million(courseInfo.enrollment_count) }}人报名</span
          >
        </p>
        <!-- 价格 -->
        <p v-if="courseInfo.goods" class="price-wrap">
          <!-- 活动价 -->
          <span v-if="courseInfo.activetyPrice" class="activity-price"
            >￥{{ courseInfo.activetyPrice }}</span
          >
          <!-- 原价 -->
          <span v-if="courseInfo.goods.fee_type === 1" class="price">免费</span>
          <span
            v-else
            class="price"
            :class="{ 'text-through': courseInfo.activetyPrice }"
            >￥{{ courseInfo.originPrice / 100 }}</span
          >
          <!-- 活动标识 -->
          <span class="activity-mark" v-if="activityText">{{
            activityText
          }}</span>
        </p>
        <p v-if="showOrgName" class="org-name">
          {{ courseInfo.org_name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import courseCard from "@saas/components/src/mixins/courseCard";
import { isH5, isMobile } from "@saas/components/src";
import { million } from "@saas/components/src/utils/utils";
export default {
  mixins: [courseCard],
  props: {
    type: {
      type: String,
      default: "big",
    },
    courseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showOrgName: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      million,
      isH5: isH5(),
    };
  },
  methods: {
    goDetail(id) {
      let url = `/product-detail/${id}`;
      if (this.iosInReview) {
        this.$router.push(`${url}?inReview=1`);
      } else if (window.isElectron || isMobile()) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
  },
  created() {
    this.iosInReview = this.$route.query.inReview === "1";
  },
};
</script>

<style lang="scss" scoped>
.hidden-ios {
  display: none !important;
}
.course-card {
  cursor: pointer;
}
.course-card .cover-cont,
.h5-course-card .cover-cont {
  position: relative;
  .free-icon {
    position: absolute;
  }
}

.course-card {
  .free-icon {
    width: 60px;
    height: auto;
    left: -5px;
  }
  .activity-icon {
    display: inline-block;
    width: auto;
    height: 20px;
    vertical-align: text-bottom;
    margin-left: 4px;
  }
}
.course-card.big-card {
  display: flex;
  margin-bottom: 25px;
  .cover-wrap {
    position: relative;
    .cover {
      width: 358px;
      height: 201px;
      border-radius: 4px;
      object-fit: cover;
    }
    .data-STATS {
      position: absolute;
      width: 100%;
      height: 24px;
      left: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      border-radius: 0px 0px 4px 4px;
      text-align: right;
      font-size: 12px;
      color: #ffffff;
      line-height: 24px;
      padding-right: 8px;
      .separate {
        margin: 0 5px;
      }
    }
    .promotion-mark {
      position: absolute;
      right: 0;
      bottom: 0;
      text-align: center;
      background-color: $activity-color;
      color: #fff;
      font-size: 0.27rem;
      line-height: 0.48rem;
      height: 0.48rem;
      padding: 0 0.16rem;
      border-radius: 0.11rem 0rem 0.11rem 0rem;
    }
  }

  .info-wrap {
    height: 201px;
    margin-left: 12px;
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 8px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }
    // .tag-wrap {
    //   .el-tag {
    //     margin-right: 6px;
    //     margin-bottom: 8px;
    //     font-size: 12px;
    //     line-height: 17px;
    //     color: $saas-theme-color;
    //     padding: 3px 12px 4px;
    //     background-color: rgba($color: $saas-theme-color, $alpha: 0.2);
    //     border-radius: 2px;
    //     height: 24px;
    //     border: none;
    //   }
    // }
    .lesson-info .price-wrap {
      display: flex;
      align-items: center;
      .free {
        font-size: 20px;
        font-weight: 500;
        color: $chiral-free-color;
      }
      .price {
        font-weight: 500;
        font-size: 16px;
        color: $chiral-price-color;
        line-height: 22px;
        display: flex;
        margin-right: 4px;
      }
      .activity-price {
        font-weight: 500;
        font-size: 16px;
        color: $chiral-price-color;
        line-height: 22px;
        display: flex;
        margin-right: 4px;
      }
      .promotion-price-mark {
        font-size: 14px;
        color: $activity-color;
      }
    }
  }
}
.course-card.small-card {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  width: 358px;
  .cover-wrap {
    position: relative;
    margin-bottom: 8px;
    .cover {
      width: 100%;
      height: 201px;
      object-fit: cover;
      border-radius: 4px;
    }
    .data-STATS {
      position: absolute;
      width: 100%;
      height: 24px;
      left: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      border-radius: 0px 0px 4px 4px;
      text-align: right;
      font-size: 12px;
      color: #ffffff;
      line-height: 24px;
      padding-right: 8px;
      .separate {
        margin: 0 5px;
      }
    }
    .promotion-mark {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: rgba($color: $activity-color, $alpha: 0.5);
      color: #fff;
      font-weight: 600;
    }
  }
  .info-wrap {
    .title {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 8px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }
    // .tag-wrap {
    //   .el-tag {
    //     margin-right: 6px;
    //     margin-bottom: 8px;
    //     font-size: 12px;
    //     line-height: 17px;
    //     color: $saas-theme-color;
    //     padding: 3px 12px 4px;
    //     background-color: rgba($color: $saas-theme-color, $alpha: 0.2);
    //     border-radius: 2px;
    //     height: 24px;
    // border: none;
    //   }
    // }
    .lesson-info .price-wrap {
      display: flex;
      align-items: center;
      .promotion-price-mark {
        font-size: 14px;
        color: $activity-color;
      }
      .free {
        font-size: 20px;
        font-weight: 500;
        color: $chiral-free-color;
      }
      .activity-price {
        font-weight: 500;
        font-size: 16px;
        color: $chiral-price-color;
        line-height: 22px;
        display: flex;
        margin-right: 5px;
      }
      .price {
        font-weight: 500;
        font-size: 16px;
        color: $chiral-price-color;
        line-height: 22px;
        display: flex;
        margin-right: 5px;
      }
    }
  }
  .org-name {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    margin-top: 8px;
  }
}
.activity-mark {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: $saas-price-color;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
  padding: 0 4px;
}

// 适配
.h5-course-card {
  .free-icon {
    width: 1.25rem;
    height: auto;
    left: -0.1rem;
  }
}
.h5-course-card.big-card {
  display: flex;
  padding: 0.43rem 0;
  .cover-wrap {
    .cover {
      width: 3.84rem;
      height: 2.16rem;
      border-radius: 0.11rem;
      object-fit: cover;
    }
    .cover-cont {
      position: relative;
    }
    .promotion-mark {
      position: absolute;
      right: 0;
      bottom: 0;
      text-align: center;
      background-color: $activity-color;
      color: #fff;
      font-size: 0.27rem;
      line-height: 0.48rem;
      height: 0.48rem;
      padding: 0 0.16rem;
      border-radius: 0.11rem 0rem 0.11rem 0rem;
    }
  }
  .info-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 0.21rem;
    flex: 1;
    width: 0;
    .title {
      font-weight: 400;
      font-size: 0.4rem;
      line-height: 0.56rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0.21rem;
    }
    // .tag-wrap {
    // .el-tag {
    //   margin-right: 0.11rem;
    //   margin-bottom: 0.11rem;
    //   font-size: 0.27rem;
    //   color: $saas-theme-color;
    //   line-height: 0.48rem;
    //   height: 0.48rem;
    //   padding: 0 0.16rem;
    //   background-color: rgba($color: $saas-theme-color, $alpha: 0.2);
    //   border-radius: 0.05rem;
    //   border: none;
    // }
    // }

    .lesson-info {
      align-items: center;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .data-STATS {
        font-size: 0.37rem;
        line-height: 0.53rem;
        color: $chiral-light-text-color;
        .separate {
          margin: 0 0.05rem;
        }
      }
    }
    .price-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .free {
        font-size: 0.4rem;
        font-weight: 500;
        color: $chiral-free-color;
      }
      .price {
        font-weight: 500;
        font-size: 0.37rem;
        color: $chiral-price-color;
        line-height: 0.4rem;
        margin-right: 5px;
      }
      .activity-price {
        font-weight: 500;
        font-size: 14px;
        color: $chiral-price-color;
        line-height: 22px;
        display: flex;
        margin-right: 4px;
      }
      .el-button--small {
        padding: 0.16rem;
      }
      .promotion-price-mark {
        font-size: 0.32rem;
        margin-left: 0.08rem;
        color: $activity-color;
      }
    }
  }
  .activity-mark {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    color: $saas-price-color;
    height: 24px;
    border-radius: 8px;
    border: 1px solid rgba($color: $saas-price-color, $alpha: 0.3);
    padding: 0 2px;
  }
}
.h5-course-card.small-card {
  width: 4.48rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.43rem;
  .cover-wrap {
    margin-bottom: 0.11rem;
    .cover-cont {
      position: relative;
    }
    .cover {
      width: 100%;
      height: 2.52rem;
      border-radius: 0.11rem;
      object-fit: cover;
    }
    .promotion-mark {
      position: absolute;
      right: 0;
      bottom: 0;
      text-align: center;
      background-color: $activity-color;
      color: #fff;
      font-size: 0.27rem;
      line-height: 0.48rem;
      height: 0.48rem;
      padding: 0 0.16rem;
      border-radius: 0.11rem 0rem 0.11rem 0rem;
    }
  }
  .info-wrap {
    .title {
      font-size: 0.4rem;
      line-height: 0.56rem;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-bottom: 0.11rem;
    }
    // .tag-wrap {
    //   .el-tag {
    //     margin-right: 0.11rem;
    //     margin-bottom: 0.11rem;
    //     font-size: 0.27rem;
    //     color: $saas-theme-color;
    //     line-height: 0.48rem;
    //     height: 0.48rem;
    //     padding: 0 0.16rem;
    //     background-color: rgba($color: $saas-theme-color, $alpha: 0.2);
    //     border-radius: 0.05rem;
    //     border: none;
    //   }
    // }
    .lesson-info {
      margin-top: 0.1rem;
      .data-STATS {
        font-size: 0.37rem;
        line-height: 0.53rem;
        color: $chiral-light-text-color;
        .separate {
          margin: 0 0.05rem;
        }
        margin-bottom: 0.19rem;
      }
    }
    .price-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .promotion-price-mark {
        font-size: 14px;
        color: $activity-color;
        margin-left: 5px;
      }
      .free {
        font-size: 0.4rem;
        font-weight: 500;
        color: $chiral-free-color;
      }
      .price {
        font-weight: 500;
        font-size: 0.48rem;
        color: $chiral-price-color;
        line-height: 0.4rem;
      }
      .promotion-price-mark {
        font-size: 0.32rem;
        margin-left: 0;
      }
    }
  }
}

.text-through {
  text-decoration: line-through;
  color: #747573 !important;
  font-size: 12px !important;
}
</style>
